<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-04')"
                                :href="`#/gescon/relatoriosconvenios/porcapa`">
                                <strong>Relatório Por Capa da Prestação</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-04')"
                                :href="`#/gescon/relatoriosconvenios/pendencias`">
                                <strong>Relatório Por Pendências</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Gescon_Relatorios_Convenios'
        }
    },
}
</script>
